import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Legal.module.scss';

const LAST_UPDATED = 'July 8, 2026';

const CookiePolicy = () => {
  const { t } = useTranslation('legal');
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className={styles.legalPage}>
      <div className={styles.legalHero}>
        <div className={styles.container}>
          <div className={styles.heroBadge}>{t('common.badge', 'Legal')}</div>
          <h1 className={styles.heroTitle}>{t('cookies.title', 'Cookie Policy')}</h1>
          <p className={styles.heroSub}>{t('common.last_updated', { date: LAST_UPDATED, defaultValue: `Last updated: ${LAST_UPDATED}` })}</p>
          <p className={styles.heroDesc}>
            {t('cookies.desc', 'This policy explains how FOTH uses cookies and similar technologies to recognize you when you visit our platform.')}
          </p>
        </div>
      </div>

      <div className={styles.legalLayout}>
        <main className={styles.legalMain} style={{ maxWidth: '800px', margin: '0 auto' }}>
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>{t('cookies.what_are_cookies.title', 'What are cookies?')}</h2>
            <div className={styles.sectionBody}>
              <p>
                {t('cookies.what_are_cookies.content', 'Cookies are small data files stored on your browser or device that allow websites to remember your preferences, keep you logged in, and analyze usage.')}
              </p>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>{t('cookies.why_we_use.title', 'Why do we use them?')}</h2>
            <div className={styles.sectionBody}>
              <p>{t('cookies.why_we_use.content', 'We use cookies to maintain your authenticated session, remember your language preference (Spanish, English, or Portuguese), and protect against CSRF attacks.')}</p>
              <ul className={styles.list}>
                <li>{t('cookies.types.essential', 'Essential Cookies: Required for technical reasons to operate the platform (e.g., keeping you logged in).')}</li>
                <li>{t('cookies.types.analytics', 'Performance & Analytics: Help us understand how people use FOTH so we can improve the design.')}</li>
                <li>{t('cookies.types.functional', 'Functional: Remember your preferences, collapsed sidebar states, and search filters.')}</li>
              </ul>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>{t('cookies.manage.title', 'How to Manage Cookies')}</h2>
            <div className={styles.sectionBody}>
              <p>
                {t('cookies.manage.content', 'You can manage cookie settings directly in your browser. Disabling essential cookies may prevent you from logging in or using platform features.')}
              </p>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default CookiePolicy;
